import React from "react";
import {
  ColProps_1,
  ColProps_13,
  ColProps_9,
  ColProps_8,
} from "@core/utils/ColProps";
import { Grid, Paper } from "@material-ui/core";
import useStyles from "./styles";
import { MarketProvider } from "@context/MarketContext";
import TradeVolume from "@features/Market/MainComponents/MarketHeader/TradeVolume";
import Warnings from "@features/Market/MainComponents/MarketHeader/Warnings";
import Settings from "@features/Market/MainComponents/MarketHeader/Settings";
import ShowCurrentCurrency from "@features/Market/MainComponents/MarketHeader/ShowCurrentCurrency";
import MarketSelectCurrency from "@features/Market/MainComponents/MarketSelectCurrency";
import MarketRecentTransactions from "@features/Market/MainComponents/MarketRecentTransactions";
import MarketChart from "@features/Market/MainComponents/MarketChart";
import MarketOrder from "@features/Market/MainComponents/MarketOrder";
import MarketTable from "@features/Market/MainComponents/MarketTable";
import OrderBook from "@features/Market/MainComponents/OrderBook";

const Template1 = () => {
  const classes = useStyles();
  return (
    <MarketProvider>
      <Grid container direction="column" spacing={10}>
        <Grid
          item
          container
          {...ColProps_1}
          justify="space-between"
          alignItems="center"
        >
          <Grid item {...ColProps_13}>
            <ShowCurrentCurrency />
          </Grid>
          <Grid
            item
            container
            direction="row"
            {...{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
            spacing={3}
            justify="space-between"
          >
            <Grid item className={classes.TradeVolume}>
              <TradeVolume />
            </Grid>
            <Grid item>
              <Warnings />
            </Grid>
            <Grid item>
              <Settings />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          container
          justify="space-between"
          alignItems="center"
          spacing={6}
          direction="row"
        >
          <Grid item container {...{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}>
            <Grid item container justify="space-between" spacing={6}>
              <Grid
                item
                {...ColProps_9}
                container
                direction="column"
                className={classes.rightContainer}
              >
                <Grid item {...ColProps_1} className={classes.marginBottom}>
                  <Paper elevation={0} className={classes.SelectCurrencyLayout}>
                    <MarketSelectCurrency />
                  </Paper>
                </Grid>
                <Grid item {...ColProps_1}>
                  <Paper
                    elevation={0}
                    className={classes.RecentTransactionsLayout}
                  >
                    <MarketRecentTransactions ListItemNumber={9} />
                  </Paper>
                </Grid>
              </Grid>
              <Grid
                item
                {...ColProps_8}
                container
                direction="column"
                className={classes.adjustSpace}
              >
                <Grid item {...ColProps_1} className={classes.marginBottom}>
                  <Paper elevation={0} className={classes.chart}>
                    <MarketChart />
                  </Paper>
                </Grid>
                <Grid item {...ColProps_1}>
                  <Paper elevation={0} className={classes.order}>
                    <MarketOrder />
                  </Paper>
                </Grid>
              </Grid>
              <Grid item {...ColProps_1}>
                <Paper elevation={0} className={classes.table}>
                  <MarketTable
                    recentMarket={false}
                    height="185px"
                    emptySize="small"
                  />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          <Grid item {...ColProps_13} container direction="column">
            <Grid item {...ColProps_1}>
              <Paper elevation={0} className={classes.OrderBook}>
                <OrderBook type="column" itemsNumber={12} template={2} />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MarketProvider>
  );
};

export default Template1;
